import { useEffect, useRef, useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
  content: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
  children?: ReactNode;
}

const HtmlIframe = ({
  content,
  className,
  style,
  title = 'HTML Content',
  children,
}: Props) => {
  const [height, setHeight] = useState<number | string>('200px');
  const ref = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR guard
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.source !== ref.current?.contentWindow) return;
      const d = event.data;
      if (
        d?.type === 'htmlBlockResize' &&
        typeof d.height === 'number' &&
        d.height >= 0
      ) {
        setHeight(d.height + 10);
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <div className={clsx('html-block-iframe-wrapper', className)} style={style}>
      <iframe
        // Remount on content change: the loader reads data-content once at
        // init, so without a fresh element the panel would keep showing the
        // previously-loaded embed when switching CRM occasions (#1663 review).
        key={content}
        ref={ref}
        data-content={content}
        src="/html_block_iframe.html"
        title={title}
        className="html-block-iframe"
        style={{ height: typeof height === 'number' ? `${height}px` : height }}
      />
      {children}
    </div>
  );
};

export default HtmlIframe;
